const MINUTE_MS = 60 * 1000;
const MINUTES_PER_DAY = 24 * 60;

/** How long a run has waited: "47m", "16h 6m", then "3d 3h"; a dash when nothing is waiting. */
export default function formatWaitingTime(since: string | null, now: Date = new Date()): string {
  if (!since) return '—';

  const minutes = Math.max(0, Math.floor((now.getTime() - new Date(since).getTime()) / MINUTE_MS));
  const days = Math.floor(minutes / MINUTES_PER_DAY);
  const hours = Math.floor((minutes % MINUTES_PER_DAY) / 60);

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes % 60}m`;
  return `${minutes}m`;
}
